import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/index.css';
import "react-alice-carousel/lib/alice-carousel.css";
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

